<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;display:flex">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png" />
        <span>巡更数据</span>
        

        <p style="margin-left:50px;margin-right:8px">查询日期:</p>
        <el-date-picker v-model="dateValue" type="date" 
            :cleable="false" value-format="yyyy-MM-dd"
             placeholder="请选择日期">
        </el-date-picker>
        <p style="margin-left:30px;margin-right:8px">巡更棒:</p>
        <el-select
          v-model="deviceNo"
          placeholder="请选择"
          style="width: 200px"
          clearable
        >
          <el-option
            v-for="item in patrolList"
            :key="item.deviceNo"
            :label="item.deviceNo"
            :value="item.deviceNo"
          >
          </el-option>
        </el-select>

        <el-button
            type="primary"
            icon="el-icon-search"
            style="height: 34px;margin-left:30px;margin-top:10px"
            size="mini"
            @click="onSubmit"
            >查询</el-button>
        <el-button type="info" icon="el-icon-document" style="height: 34px;margin-top:10px" plain @click="downLoad"
            >导出</el-button>
      </div>
    </div>
    <div class="row_link clearfix">
      <table v-for="info,idx in infoList" class="table">
        <tr v-if="idx == 0">
          <td :colspan="2+timeList.length">
           <p style="font-size: 18px;font-weight:500;height:40px;line-height:40px"> {{ queryDay }} 日巡查记录表</p>
          </td>
        </tr>
        <tr v-if="idx == 0" class="firstLine">
          <td>巡更棒</td>
          <td>巡更点</td>
          <td v-for="item in timeList">
            <span>{{ item.startTime }}</span>
            <br/>
            <span>{{ item.endTime }}</span>
          </td>
        </tr>
        <tr v-for="point,index in info.timeRecordListVoList[0].pointRecordVos" class="firstLine">
          <td v-if="index == 0" :rowspan="info.timeRecordListVoList[0].pointRecordVos.length">
            <span>{{info.deviceNo}}</span>
            <br/>
            <span>{{info.userName}}</span>
          </td>
          <td>
            <el-tooltip class="item" effect="dark" :content="point.location" placement="right-start">
              <p class="name2">{{point.location}}</p>
            </el-tooltip>
          </td>
          <td v-for="item,itx in info.timeRecordListVoList">
            <el-tooltip v-if="item.pointRecordVos[index].patrolRecordVoList.length!=0" 
              class="item" effect="dark" :content="'巡更人:'+item.pointRecordVos[index].patrolRecordVoList[0].userName+' 巡更时间:'+item.pointRecordVos[index].patrolRecordVoList[0].patrolTime" placement="right-start">
              <i class="el-icon-check" style="font-size: 22px;color:black"/>
            </el-tooltip>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import util from "@/utils/util.js";
import { baseURL } from "@/utils/request.js";
export default {
  name: "PatrolView",
  data() {
    return {
      dateValue:util.formatDate.format(new Date(), "yyyy-MM-dd"),
      deviceNo:null,
      queryDay:'',
      infoList: [], //数据源
      timeList:[],
      patrolList:[],
    };
  },
  methods: {
    getDayRecord(){
      let params = {
        dayStr:this.dateValue,
        deviceNo: this.deviceNo
      }
      this.$postJson("dmc/patrolReminder/queryDayView", params).then(res=>{
        this.infoList = res.result.patrolListVoList;
        this.queryDay = res.result.dayString;
        console.log(this.infoList);
        if(res.result.patrolListVoList!=null && res.result.patrolListVoList.length>0){
          this.timeList = res.result.patrolListVoList[0].timeRecordListVoList;
        }
      })
    },
    onSubmit(){
      this.getDayRecord();
    },
    getPatrolList(){
      let param = {
        pageNum: 1,
        pageSize: 999,
      };
      this.$postJson("dmc/patrol/queryGroupPatrolListWithPage", param).then(res=>{
        this.patrolList = res.result.list;
      })
    },
    downLoad(){
      let dayStr = ``;
      let deviceNo = ``;
      if (this.dateValue) {
        dayStr = `&dayStr=${this.dateValue}`;
      }
      if (this.deviceNo) {
        deviceNo = `&deviceNo=${this.deviceNo}`;
      }

      window.location.href =
        baseURL +
        `dmc/api/patrolShowDown?groupId=${sessionStorage.getItem(
          "groupId"
        )}${dayStr}${deviceNo}`;
    },
  },
  mounted() {
    this.getDayRecord();
    this.getPatrolList();
  }
};
</script>
<style lang="scss" scoped>
.public_bg {
  width: 100%;
  min-height: 95%;
  padding: 0 0 20px 0;
  background: #fefefe;
  .nurse_top {
    border: 1px #f1eff2 solid;
    background: #f9f7fa;
    position: relative;
    img {
      margin: 14px 12px;
    }
    h5 {
      display: inline-block;
      position: absolute;
      top: 12px;
      font-size: 18px;
    }
  }
}
.table{
  border-spacing: 0px;
  width: 100%;
  border-collapse: collapse;
  td{
    border: 0.3px gray solid;
    min-width: 60px;
    text-align: center;
    height: 22px;
    max-lines: 1;
  }
  .name2{
    max-width: 90%;
    white-space: nowrap;
    font-size: 11px;
    text-align: center;
    max-lines: 1;
    overflow: hidden;
  }
}

</style>
